module.exports = __webpack_public_path__ + "img/propheciesGround.2e85fed9.svg";